import { IRangeDate } from "./utils-types";

export const addZero = (number: number): string =>
  `${(number < 10 ? "0" : "") + number}`;

export const milisecondsToFormatedTime = (
  milisecondsReceived: number,
  hourFormat = " horas"
) => {
  milisecondsReceived = Math.abs(milisecondsReceived);

  const days = Math.floor(milisecondsReceived / 1000 / 60 / 60 / 24);
  const hours = Math.floor((milisecondsReceived / 1000 / 60 / 60) % 24);
  const minutes = Math.floor((milisecondsReceived / 1000 / 60) % 60);

  const timeArray = [];

  if (days > 0) {
    timeArray.push(`${addZero(days)} dia${days > 1 ? "s" : ""}`);
  }
  if (hours > 0) {
    timeArray.push(`${addZero(hours)}${hourFormat}`);
  }

  timeArray.push(`${addZero(minutes)} min`);

  return timeArray.join(" ");
};

export const getTimeLeft = (date: string) => {
  const receivedDate: Date = new Date(date);
  const currentDate: Date = new Date();
  const diffTime: number = receivedDate.getTime() - currentDate.getTime();

  if (diffTime <= 0) return "00d 00h 00m";

  const minutes = Math.floor((diffTime / 1000 / 60) % 60);
  const hours = Math.floor((diffTime / 1000 / 60 / 60) % 24);
  const days = Math.floor(diffTime / 1000 / 60 / 60 / 24);

  const ReceivedDifferenceDate =
    days > 0
      ? `${addZero(days)}d ${addZero(hours)}h ${addZero(minutes)}m`
      : `${addZero(hours)}h ${addZero(minutes)}m`;

  return ReceivedDifferenceDate;
};

export const getTimeDiff = (date: string) => {
  const receivedDate: Date = new Date(date);
  const currentDate: Date = new Date();
  const diffTime: number = currentDate.getTime() - receivedDate.getTime();

  if (diffTime <= 0) return "00h 00m";

  const minutes = Math.floor((diffTime / 1000 / 60) % 60);
  const hours = Math.floor((diffTime / 1000 / 60 / 60) % 24);
  const days = Math.floor(diffTime / 1000 / 60 / 60 / 24);

  const ReceivedDifferenceDate =
    days > 0
      ? `${addZero(days)}d ${addZero(hours)}h ${addZero(minutes)}m`
      : `${addZero(hours)}h ${addZero(minutes)}m`;

  return ReceivedDifferenceDate;
};

export const countHoliday = (
  start: Date,
  end: Date,
  holidays: string[] = []
) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  let days = 0;

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  holidays.forEach(holiday => {
    const holidayDate = new Date(holiday);
    if (
      ![0, 6].includes(holidayDate.getDay()) &&
      startDate.getTime() <= holidayDate.getTime() &&
      holidayDate.getTime() <= endDate.getTime()
    )
      days++;
  });

  return days;
};

export const getDateDiffDay = (
  start: Date,
  end: Date,
  holidays: string[],
  isWeekdays = true
) => {
  const millisecondsPerDay = 86400 * 1000; // Day in milliseconds
  let days = 0;

  if (start && end) {
    start.setHours(0, 0, 0, 1); // Start just after midnight
    end.setHours(23, 59, 59, 999); // End just before midnight

    const diff = end.getTime() - start.getTime(); // Milliseconds between datetime objects

    if (!isWeekdays) return Math.ceil(diff / millisecondsPerDay);

    // Calculate days between dates

    days = Math.ceil(diff / millisecondsPerDay);

    // Subtract two weekend days for every week in between
    const weeks = Math.floor(days / 7);
    days = days - weeks * 2;

    // Handle special cases
    const startDay = start.getDay();
    const endDay = end.getDay();

    // Remove weekend not previously removed.
    if (startDay - endDay > 1) days = days - 2;

    // Remove start day if span starts on Sunday but ends before Saturday
    if (startDay === 0 && endDay !== 6) days = days - 1;

    // Remove end day if span ends on Saturday but starts after Sunday
    if (endDay === 6 && startDay !== 0) days = days - 1;

    // Remove holidays
    days = days - countHoliday(start, end, holidays);
  }

  return days;
};

export const correctionFactoreDateEnd = (
  dateRange: IRangeDate,
  days: number,
  holidays: string[],
  isWeekdays = true
) => {
  const start = new Date(dateRange.start.getTime());
  let end = new Date(dateRange.end.getTime());

  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  if (
    isWeekdays &&
    dateRange.start &&
    dateRange.end &&
    holidays &&
    holidays.length
  ) {
    let workdays = getDateDiffDay(start, dateRange.end, holidays);
    let steps = 0;

    while (days > workdays && steps < 366) {
      steps++;
      const plusDay = dateRange.end.setDate(
        dateRange.end.getDate() + (days - workdays)
      );
      end = new Date(plusDay);

      workdays = getDateDiffDay(start, end, holidays);
    }
  }

  return end;
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString + " 00:00");
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day > 9 ? day : "0" + day}/${month > 9 ? month : "0" + month}/${
    year > 9 ? year : "0" + year
  }`;
};

export const sameHourDate = (date: string) => {
  const selectedDate = new Date(date);
  return selectedDate.setHours(0, 0, 0, 0);
};

export const dateToISOString = (date: Date) => {
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);
  return date.toISOString().split("T")[0];
};
